import { useGlobalStore } from '@/store/useGlobalStore';
import { useViewportStore } from '@/store/useViewportStore';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
const tabInfo = ['트립', '마켓'];

const HomeTypeTab = () => {
  const router = useRouter();
  const isMobile = useViewportStore((store) => store.isMobile);

  const [tab, setTab] = useState(tabInfo[0]);
  const setKind = useGlobalStore((store) => store.setKind);

  const handleTabClick = (nextTab: string) => {
    if (nextTab === '트립') {
      router.push('/?type=체험');
      setKind('experience');
    } else if (nextTab === '마켓') {
      router.push('/?type=마켓');
      setKind('market');
    }
  };

  useEffect(() => {
    if (!router.isReady) return;

    if (router.pathname === '/') {
      if (router.query.type === '체험') {
        setTab(tabInfo[0]);
      } else if (router.query.type === '마켓') {
        setTab(tabInfo[1]);
      }
    }
  }, [router.isReady, router.query.type, router.pathname]);

  return (
    <Tabs $isMobile={isMobile}>
      {tabInfo.map((item) => (
        <Tab
          key={item}
          active={tab === item}
          $isMobile={isMobile}
          onClick={() => handleTabClick(item)}>
          {item}
        </Tab>
      ))}
    </Tabs>
  );
};
export default HomeTypeTab;

const Tabs = styled.div<{ $isMobile: boolean }>`
  display: flex;
  ${({ $isMobile, theme }) =>
    $isMobile
      ? `
      width: 100%;
      border-radius: 10px;
      border: 1px solid ${theme.colors.gray200};
      padding: 3px;
      background-color: ${theme.colors.white};
      margin-bottom: 10px;
    `
      : `
      width: 100%;
      padding: 3px;
      border: 1px solid ${theme.colors.gray200};
      border-radius: 10px;
      background-color: ${theme.colors.white};
      margin: 0 0 22px;
    `}
`;

const Tab = styled.button<{ active?: boolean; $isMobile: boolean }>`
  appearance: none;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: ${({ $isMobile }) => ($isMobile ? '4px' : '0')};
  min-height: ${({ $isMobile }) => ($isMobile ? 'auto' : '50px')};
  padding: ${({ $isMobile }) => ($isMobile ? '9px 12px' : '8px 24px')};
  border-radius: 8px;
  border: 1px solid ${({ active, theme }) => (active ? theme.colors.primary : 'transparent')};
  background-color: ${({ active, theme, $isMobile }) =>
    active ? ($isMobile ? theme.colors.primaryRGB : '#D9FBF6') : 'transparent'};
  color: ${({ active, theme, $isMobile }) =>
    active ? theme.colors.black : $isMobile ? theme.colors.gray700 : theme.colors.gray800};
  font-size: ${({ $isMobile }) => ($isMobile ? '15px' : '21px')};
  font-weight: ${({ active, $isMobile }) => (active ? '700' : $isMobile ? '600' : '600')};
  cursor: pointer;
  line-height: 1.1;
  transition: ${({ $isMobile }) =>
    $isMobile
      ? 'background-color 0.2s ease, border-color 0.2s ease'
      : 'background-color 0.25s ease, border-color 0.25s ease, color 0.25s ease'};
`;
